import styled from 'styled-components';

import { TileContainer } from '~src/styles/containers.sc';

export const ContentContainer = styled.div`
  padding: 20px 30px;
  .success,
  .fail {
    font-size: 1.2rem;
    font-weight: bold;
  }
  .fail {
    margin: 15px 0 5px;
    color: ${({ theme }) => theme.red.a10};
  }
`;

export const SummaryTile = styled(TileContainer)`
  margin: 30px 0;
`;

export const UsersList = styled.ul`
  margin-left: 30px;
  li {
    padding: 5px 15px 5px 0;
    list-style-type: disc;
    span {
      color: ${({ theme }) => theme.red.a10};
      font-style: italic;
      font-size: 0.8rem;
    }
  }
`;
